import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink, CardSlider, HoveredImage } from '../../../components';

import '../GovernancaDefault.scss';
import './Governanca.scss';

class Governanca extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,
    };

    this.images = images;
    this.texts = texts;

    this.contentText = React.createRef();
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    const sliderItems = [
      { text: `Eleger e destituir as pessoas que compõem a Diretoria e os conselhos Fiscal e de Ética.` },
      { text: `Deliberar sobre as contas e as demonstrações financeiras.` },
      { text: `Aprovar a criação ou mudanças em códigos de autorregulação.` },
      { text: `Aprovar qualquer mudança no Código de Ética.` },
    ];
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Assembleia Geral - Governança Corporativa - {this.texts.title}</title>
        </Helmet>

        <div className="governanca-home page-gradient page-gradient--blue bg-gray" ref="governanca-home">
          <section className="governanca-home-area governanca-header page-gradient__header">
            <div className="container tela-max">
              <div className="page-header">
                <h1 className="page-header__title tituto-top">
                  <img src={this.images.governanca.icon_titulo_top} />
                  Assembleia geral
                </h1>
              </div>
            </div>
            <div className="container tela-max-top">
              <div className="row flex">
                <div className="col-7">
                  <Fade bottom>
                    <div className="page-header pading-medio">
                      <p className="page-header__description gri_text_top texto-gri-descricao">
                        As decisões dos associados são a base para a nossa governança corporativa e a assembleia geral é
                        o órgão máximo de decisão. Nela, cada instituição tem direito a um voto.
                        <br />
                        <span className="gri_label gri-assembleia-left gri-assembleia-first-left">
                          GRI <b>102-18</b>
                        </span>
                      </p>
                      <p className="page-header__description gri_text_top_desc">
                        O membro votante de cada assembleia não possui mandato, é um representante da instituição,
                        indicado e substituído por ela sem prazo definido. As votações acontecem anualmente na
                        assembleia geral ordinária, feita no primeiro quadrimestre do ano, e sempre que necessário na
                        assembleia extraordinária.
                        <br />
                        <span className="gri_label_3 gri-assembleia-left">
                          GRI <b>102-22, 102-24</b>
                        </span>
                      </p>
                    </div>
                  </Fade>
                </div>
                <div className="image-topo-container col-5">
                  <div className="row">
                    <Fade>
                      <div className="col-12 pessoas-animadas">
                        <img src={this.images.governanca.pessoas_topo1} className="pessoas-topo1-assembleia" />
                        <img src={this.images.governanca.pessoas_topo2} className="pessoas-topo2-assembleia" />
                        <img src={this.images.governanca.pessoas_topo_mobile} className="pessoas-topomobile" />
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="governanca-body governanca-body--card page--blue">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <p className="gri_text_top2 titulo-assembleia-geral-2020">
                        <br />
                        Atividades da assembleia geral
                        <p>
                          É a assembleia que toma as decisões mais estratégicas da Associação, que incluem:
                          <br />
                          <span className="gri_label_4 gri-assembleia-left">
                            GRI <b>102-26</b>
                          </span>
                        </p>
                      </p>
                    </Fade>
                  </div>
                </div>

                <div className="row bloco_blocos">
                  <div className="bloco_1 bloco">
                    <img src={this.images.governanca.fundo_blocos} className="fundo_blocos" />
                    <div className="bloco_1_anime">
                      <p>Eleger e destituir as pessoas que compõem a Diretoria e os conselhos Fiscal e de Ética.</p>
                    </div>
                  </div>
                  <div className="bloco_2 bloco">
                    <img src={this.images.governanca.fundo_blocos} className="fundo_blocos" />
                    <div className="bloco_2_anime">
                      <p>Deliberar sobre as contas e as demonstrações financeiras.</p>
                    </div>
                  </div>
                  <div className="bloco_3 bloco">
                    <img src={this.images.governanca.fundo_blocos} className="fundo_blocos" />
                    <div className="bloco_3_anime">
                      <p>Aprovar a criação ou mudanças em códigos de autorregulação.</p>
                    </div>
                  </div>
                  <div className="bloco_4 bloco">
                    <img src={this.images.governanca.fundo_blocos} className="fundo_blocos" />
                    <div className="bloco_4_anime">
                      <p>Aprovar qualquer mudança no Código de Ética.</p>
                    </div>
                  </div>
                </div>

                <div className="col-12">
                  <div className="governanca-body__content">
                    <Fade bottom>
                      <p className="last_description gri_text">
                        Logo abaixo da assembleia, vem a Diretoria e os conselhos Fiscal e de Ética, órgãos formados por
                        membros voluntários do mercado.
                        <br />
                        <span className="gri_label gri-assembleia-left gri-font-media-2020">
                          GRI <b>102-35</b>
                        </span>
                      </p>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="diretoria-box-area governanca-footer">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-3">
                            {/* <img src={images.governanca.pessoa1} className="pessoa_destaque pessoa_destaque--1" /> */}
                          </div>
                          <div className="col col-9 col--text">
                            <h4 className="footer-governanca-2020">Veja como é formada a nossa Diretoria</h4>
                            <DelayLink
                              to="/governanca-corporativa/diretoria"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { Governanca };
